/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f53600232c28b0c38240a7438719c9bc>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Highlight".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/highlight
 * Usage guidance:
 * Single purpose - Reserved for highlight text tool in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const HighlightIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  name: "HighlightIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.516.31a1.375 1.375 0 0 1 1.76.155l1.259 1.26c.471.47.537 1.212.155 1.759L9.365 9.679a.75.75 0 0 1-.363.277l-3.5 1.25a.75.75 0 0 1-.782-.176l-.095-.094-.595.594a.75.75 0 0 1-1.06 0l-.5-.5a.75.75 0 0 1 0-1.06l.594-.595-.094-.095a.75.75 0 0 1-.176-.782l1.25-3.5a.75.75 0 0 1 .277-.363zm.773 1.29L5.913 5.353l2.734 2.734L12.4 2.71zM7.382 8.942 5.058 6.618l-.692 1.937 1.079 1.08z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
HighlightIcon.displayName = 'HighlightIcon';
var _default = exports.default = HighlightIcon;